import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory } from "react-router-dom";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";

const NewUser = () => {
  let history = useHistory();

  useEffect(() => {
    getAndSetCustomers();
  }, []);

  const [customers, setCustomers] = useState([]);

  const getAndSetCustomers = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/customers`
      );
      if (response.data?.customers) {
        setCustomers(response.data.customers);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    if (customers.length > 0) {
      formik.setFieldValue(
        "customer",
        customers.find((customer) => customer.name === "server-builds")?._id
      );
    }
  }, [customers]);

  const submit = async (values, { resetForm }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/users/register`,
        values
      );
      if (response.status === 200) {
        resetForm();
        history.push("/admin/users");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const UserSchema = Yup.object().shape({
    fullName: Yup.string().min(1, "Too Short!").required("Required"),
    email: Yup.string().email("Invalid email address").required("Required"),
    password: Yup.string().min(1, "Too Short!").required("Required"),
    userGroup: Yup.string().min(1, "Too Short!").required("Required"),
    customer: Yup.string().min(1, "Too Short!").required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      password: "",
      userGroup: "admin",
      customer: null,
    },
    validateOnMount: true,
    validationSchema: UserSchema,
    onSubmit: submit,
  });

  const { fullName, email, password, userGroup, customer } = formik.values;

  return (
    <div>
      <Container>
        <Row>
          <Col xs={{ span: 10, offset: 1 }} md={{ span: 6, offset: 3 }}>
            <div className="page">
              <h1>New User</h1>
              <Form onSubmit={formik.handleSubmit}>
                <Form.Group controlId="fullName" size="lg">
                  <Form.Label>Full name</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={fullName}
                    onChange={formik.handleChange}
                    isValid={formik.touched.fullName && !formik.errors.fullName}
                  />
                </Form.Group>
                <Form.Group controlId="email" size="lg">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={email}
                    onChange={formik.handleChange}
                    isValid={formik.touched.email && !formik.errors.email}
                  />
                </Form.Group>
                <Form.Group controlId="password" size="lg">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={password}
                    onChange={formik.handleChange}
                    isValid={formik.touched.password && !formik.errors.password}
                  />
                </Form.Group>
                <Form.Group controlId="userGroup" size="lg">
                  <Form.Label>User Group</Form.Label>
                  <Form.Control
                    as="select"
                    name="userGroup"
                    value={userGroup}
                    onChange={(e) => {
                      console.log("e.target.value", e.target.value);
                      formik.setFieldValue("userGroup", e.target.value);
                    }}
                  >
                    <option value="admin">Admin</option>
                    <option value="editor">Editor</option>
                    <option value="configurator">Configurator</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId="userGroup" size="lg">
                  <Form.Label>Customer</Form.Label>
                  <Form.Control
                    as="select"
                    name="customer"
                    value={customer}
                    onChange={(e) => {
                      console.log("e.target.value", e.target.value);
                      formik.setFieldValue("customer", e.target.value);
                    }}
                  >
                    {customers.map((customer) => {
                      return (
                        <option key={customer._id} value={customer._id}>
                          {customer.name}
                        </option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
                <Button
                  block
                  size="lg"
                  type="submit"
                  disabled={Object.keys(formik.errors).length !== 0}
                >
                  Create New User
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewUser;
